import AxiosService from './axios.service';
import { AxiosResponse } from 'axios';
import { CreateGrupoDto, Grupo } from './types/cursos.types';

export class GruposService {
  static async create(dto: CreateGrupoDto): Promise<Grupo> {
    const response: AxiosResponse<Grupo> = await AxiosService.post('/grupos', dto);
    return response.data;
  }

  static async findAll(): Promise<Grupo[]> {
    const response: AxiosResponse<Grupo[]> = await AxiosService.get('/grupos');
    return response.data;
  }

  static async findOne(id: string): Promise<Grupo> {
    const response: AxiosResponse<Grupo> = await AxiosService.get(`/grupos/${id}`);
    return response.data;
  }

  static async remove(id: string): Promise<void> {
    await AxiosService.delete(`/grupos/${id}`);
  }

  static async addUsuario(id: string, usuarioRut: string): Promise<Grupo> {
    const response: AxiosResponse<Grupo> = await AxiosService.post(`/grupos/${id}/usuarios`, { usuarioRut });
    return response.data;
  }

  static async removeUsuario(id: string, usuarioRut: string): Promise<Grupo> {
    const response: AxiosResponse<Grupo> = await AxiosService.delete(`/grupos/${id}/usuarios/${usuarioRut}`);
    return response.data;
  }
}
